// Check if url is localhost with port (not through traefik). If so, set apiUrl to localhost:5000. If not, api is on same url

let baseUrl = window.location.origin === 'http://localhost:3000' ? 'http://localhost:5000' : window.location.origin

// Check if we're on an IP
if(window.location.hostname.split(':')[0].match(/(^127\.0\.0\.1)|(^192\.168)|(^10\.)|(^172\.1[6-9])|(^172\.2[0-9])|(^172\.3[0-1])/)){
  baseUrl = `http://${window.location.hostname}:5000`
}

const config = {
  apiUrl: `${baseUrl}/api/v1`
  //apiUrl: `http://localhost:5000/api/v1`
}

export default config



// WEBPACK FOOTER //
// ./src/store/config.js